import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, MailX, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

const L = {
  it: {
    confirm: {
      title: "Iscrizione confermata",
      text: "Grazie! Da ora riceverai i nuovi articoli e le guide del sito, direttamente nella tua email."
    },
    cancel: {
      title: "Iscrizione annullata",
      text: "La tua email è stata rimossa dalla newsletter. Non riceverai più messaggi da noi."
    },
    error: "Link non valido o scaduto.",
    cta: "Torna alla home",
    loading: "Verifica in corso…"
  },
  en: {
    confirm: {
      title: "Subscription confirmed",
      text: "Thank you! From now on you will receive new articles and guides straight to your inbox."
    },
    cancel: {
      title: "Subscription cancelled",
      text: "Your email has been removed from the newsletter. You will not hear from us again."
    },
    error: "Invalid or expired link.",
    cta: "Back to home",
    loading: "Verifying…"
  }
};

export default function NewsletterResult({ mode = "confirm" }) {
  const { lang } = useLang();
  const a = L[lang][mode === "cancel" ? "cancel" : "confirm"];
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!token) {
      setState("error");
      return;
    }
    const endpoint = mode === "cancel" ? "/newsletter/unsubscribe" : "/newsletter/confirm";
    api
      .get(endpoint, { params: { token } })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [token, mode]);

  return (
    <section data-testid={`newsletter-${mode}-page`} className="flex min-h-screen items-center justify-center bg-navy px-6 noise">
      <div className="max-w-md text-center">
        {state === "loading" ? (
          <Loader2 className="mx-auto h-10 w-10 animate-spin text-gold" />
        ) : state === "error" ? (
          <>
            <MailX className="mx-auto h-12 w-12 text-red-400" />
            <h1 className="mt-6 font-serif text-3xl text-ivory">{L[lang].error}</h1>
          </>
        ) : (
          <>
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-gold-bright">
              <Check className="h-8 w-8" />
            </span>
            <h1 className="mt-8 font-serif text-3xl text-ivory sm:text-4xl" data-testid={`newsletter-${mode}-title`}>{a.title}</h1>
            <p className="mt-4 text-sm leading-relaxed text-ivory/60">{a.text}</p>
          </>
        )}
        {state !== "loading" && (
          <Link
            to="/"
            data-testid="newsletter-result-home-link"
            className="mt-10 inline-block border border-gold/40 px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-gold-bright transition-colors hover:bg-gold/10"
          >
            {L[lang].cta}
          </Link>
        )}
      </div>
    </section>
  );
}
